import {
  DeleteResponseResponseDTO,
  GetListContentTypesResponseDTO,
  GetListResponseDTO,
  GetRequestResponsesResponseDTO,
  GetResponseDetailDTO,
  PutResponseStatusResponseDTO
} from '@twygs/shared/publisher-interface';
import axiosInstance from './axios-instance';

export const createResponse = async (payload) => {
  const result: GetResponseDetailDTO = await axiosInstance.post(`/api/v1/publisher/responses`, {
    ...payload
  });
  return result.data;
};

export const fetchListResponses = async (pagination) => {
  const result: GetListResponseDTO = await axiosInstance.get(`/api/v1/publisher/responses/me`, {
    params: pagination
  });
  return result.data;
};

export const fetchListRequestResponses = async (id, params) => {
  const result: GetRequestResponsesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/requests/${id}/responses`,
    {
      params
    }
  );
  return result.data;
};

export const fetchResponseContentTypes = async (pagination) => {
  const result: GetListContentTypesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/responses/content-types`,
    {
      params: pagination
    }
  );
  return result.data;
};

export const deleteResponse = async (id) => {
  try {
    const result: DeleteResponseResponseDTO = await axiosInstance.delete(
      `/api/v1/publisher/responses/${id}`
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting responses:', error);
    throw error;
  }
};

export const approveResponse = async (id) => {
  try {
    const result: PutResponseStatusResponseDTO = await axiosInstance.put(
      `/api/v1/publisher/responses/${id}/status`,
      {
        status: 'approved'
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting responses:', error);
    throw error;
  }
};

export const rejectResponse = async (id) => {
  try {
    const result: PutResponseStatusResponseDTO = await axiosInstance.put(
      `/api/v1/publisher/responses/${id}/status`,
      {
        status: 'rejected'
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting responses:', error);
    throw error;
  }
};

export const getResponseDetail = async (id) => {
  try {
    const result: GetResponseDetailDTO = await axiosInstance.get(
      `/api/v1/publisher/responses/${id}/detail`
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting responses:', error);
    throw error;
  }
};
